import type { RouteRecordRaw, Router } from 'vue-router'
import { MODULE_PERMISSIONS } from '@/modules/Core/constants/adminAccess'

const UserRoutes: RouteRecordRaw = {
  path: '/user',
  name: 'UserModulePages',
  redirect: { name: 'ManageUsersRoute' },
  children: [
    {
      path: '',
      name: 'ManageUsersRoute',
      component: () => import('./views/ManageUsersView.vue'),
      meta: {
        title: 'کارمندان',
      },
    },
    {
      path: ':employeeId/evaluations',
      name: 'EmployeeEvaluationsRoute',
      component: () => import('./views/EmployeeEvaluationsView.vue'),
      meta: {
        title: 'ارزشیابی',
        pageHasBack: true,
      },
    },
    {
      path: ':employeeId/evaluations/:formId/statistics',
      name: 'EmployeeEvaluationStatisticsRoute',
      component: () => import('./views/EmployeeEvaluationStatisticsView.vue'),
      meta: {
        title: 'نتیجه ارزشیابی',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
    requiredPermissions: [...MODULE_PERMISSIONS.user],
  },
}

export default (router: Router) => {
  router.addRoute(UserRoutes)
}
